import type { ReactNode } from "react";

/**
 * A labelled value in a flight row.
 * @param props.label - Small label above the value.
 * @param props.children - The value.
 * @returns The field.
 * @throws Never.
 */
export const FlightField = ({ label, children }: { label: string; children: ReactNode }) => (
  <span className="flex min-w-0 flex-col gap-0.5">
    <span className="text-xs font-medium text-gray-600">{label}</span>
    <span className="text-sm font-medium tabular-nums text-gray-900">{children}</span>
  </span>
);
